import React, { useMemo, useState } from "react";
import RffForm from "../RffForm";
import { useFormState } from "react-final-form";
import PdfPreviewer from "../../pdf/components/PdfPreviewer";
import { Box, Button } from "@mui/material";
import Flx from "../../layout/Flx";
import {
  EditOutlined,
  VisibilityOffOutlined,
  VisibilityOutlined,
} from "@mui/icons-material";
import PdfDownloadButton from "../../pdf/components/PdfDownloadButton";
import Txt from "../../typography/Txt";

const RffPrimaryCardPdfPreview = ({
  children,
  initialValues,
  loading,
  maxWidth = "md",
  formSpy,
  headerEndContent,
  subTitle,
  previewHeight = "78vh",
  defaultShowPreview = true,
  hideTitle = false,
  cardSx,
  title,
  filename = "document.pdf",
  pdf,
}) => {
  const [showPreview, setShowPreview] = useState(defaultShowPreview);

  const toggleButtonText = useMemo(() => {
    if (defaultShowPreview) {
      return showPreview ? "Edit PDF Values" : "Show Preview";
    }
    return showPreview ? "Hide Preview" : "Show Preview";
  }, [defaultShowPreview, showPreview]);

  const toggleButtonIcon = useMemo(() => {
    if (defaultShowPreview) {
      return showPreview ? (
        <EditOutlined className="thin" />
      ) : (
        <VisibilityOutlined className="thin" />
      );
    }
    return showPreview ? (
      <VisibilityOffOutlined className="thin" />
    ) : (
      <VisibilityOutlined className="thin" />
    );
  }, [defaultShowPreview, showPreview]);

  return (
    <FormWrapper formSpy={formSpy} initialValues={initialValues}>
      <Flx jb ac sx={{ mb: 1 }}>
        <Txt bold>{title}</Txt>
        <Flx ac gap={1}>
          {children ? (
            <Button
              variant="outlined"
              startIcon={toggleButtonIcon}
              onClick={() => setShowPreview(!showPreview)}
            >
              {toggleButtonText}
            </Button>
          ) : null}
          <PdfDownloadButton filename={filename} injectFinalFormValues>
            {/* <PdfPreview onlyChildren>{pdf}</PdfPreview> */}
            {pdf}
          </PdfDownloadButton>
          {headerEndContent}
        </Flx>
      </Flx>
      {showPreview && (
        <PdfPreview previewHeight={previewHeight}>{pdf}</PdfPreview>
      )}
      {children ? (
        <Box sx={{ height: showPreview ? 0 : "auto", overflow: "hidden" }}>
          {children}
        </Box>
      ) : null}
    </FormWrapper>
  );
};

const PdfPreview = ({ children, onlyChildren, previewHeight = "78vh" }) => {
  const { values } = useFormState();

  const rendered = React.isValidElement(children)
    ? React.cloneElement(children, { formData: values, data: values, values }) // or { formData: values }
    : children;
  if (onlyChildren) {
    return rendered;
  }
  return (
    <PdfPreviewer
      sx={{ height: previewHeight, width: "100%", minHeight: "720px" }}
    >
      {rendered}
    </PdfPreviewer>
  );
};

const FormWrapper = ({ initialValues, children, formSpy }) => {
  return (
    <RffForm suppressFooter formSpy={formSpy} initialValues={initialValues}>
      {children}
    </RffForm>
  );
};

export default RffPrimaryCardPdfPreview;
